import { DirectorySettings, SkillCategory } from '@accredible-frontend-v2/models';

export interface SpotlightDirectory extends DirectorySettings {
  skills: string[];
  categories: SkillCategory[];
}
